import React, {useEffect, useState} from 'react'
import { useNavigate } from 'react-router-dom'
import { useUserContext } from '../../context/users/UserContext'
import {addPhotos, getCategories} from "../../context/photos/PhotoActions";
import { 
  FaImage, 
  FaFolderOpen, 
  FaSave, 
  FaExclamationTriangle,
  FaCheckCircle,
  FaUpload
} from 'react-icons/fa'
import { Card, Row, Col, Form, Button } from 'react-bootstrap'
import './AddPhoto.css'

// eslint-disable-next-line
export default function AddPhoto () {

  const navigate = useNavigate()
  const {  setAlert } = useUserContext()
  // const { } = usePhotoContext();

  const [file, setFile] = useState(null)
  const [categories, setCategories] = useState([])
  const [categoryName, setCategoryName] = useState('')
  const [inputValue, setInputValue] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const [errors, setErrors] = useState({})
  const [showSuggestions, setShowSuggestions] = useState(false)

  useEffect(() => {
    const getCate = async () => {

      const category = await getCategories();
      setCategories(category)

    }
    getCate()
  }, [])


  const handleChangeFile = (e) => {
    const f = e.target.files[0];
    if (f) {
      const maxSize = 1024 * 1024; // 1 MB in bytes
      if (f.size > maxSize) {
        setAlert({
          message: 'Archivo excede el tamaño permitido de 1 MB',
          msgType: 'warning'
        });
        setFile(null);
        setErrors(prev => ({ ...prev, file: 'El archivo excede el tamaño permitido de 1 MB' }));
        return;
      }
      setFile(f);
      setErrors(prev => ({ ...prev, file: '' }));
    }
  };

  const handleInput = (e) => {
    const value = e.target.value;
    setInputValue(value);
    setShowSuggestions(value.length > 0);
    setErrors(prev => ({ ...prev, category: '' }));
  };

  const handleCategorySelect = (category) => {
    setCategoryName(category.categoryName);
    setInputValue(category.categoryName);
    setShowSuggestions(false);
  };

  const validateForm = () => {
    const newErrors = {};

    if (!file) {
      newErrors.file = 'Debe seleccionar una imagen';
    }

    if (!inputValue.trim()) {
      newErrors.category = 'La categoría es requerida';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const handleSubmit = async (e) => {
    e.preventDefault()

    if (!validateForm()) {
      setAlert({
        message: 'Por favor corrige los errores en el formulario',
        msgType: 'warning'
      })
      return
    }

    setIsLoading(true)

    try {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("fileDto", JSON.stringify({
        appId: 1,
        categoryName: inputValue.trim().toLowerCase()
      }));

      const newFile = await addPhotos(formData)

      setAlert({
        message: 'Fotografía agregada exitosamente',
        msgType: 'success'
      })

      setFile(null);
      setCategoryName('');
      setInputValue('');
      navigate('/fotografias');
    } catch (error) {
      setAlert({
        message: 'Error al agregar la fotografía',
        msgType: 'warning'
      })
    } finally {
      setIsLoading(false)
    }
  }

  const handleCancel = () => {
    navigate('/fotografias')
  }

  window.scrollTo({
    top: 0,
    behavior: 'auto',
  })

  return (
    <div className="add-photo-container">
      <div className="container">
        <Row className="justify-content-center">
          <Col lg={8} md={10} sm={12}>
            {/* Header */}
            <div className="page-header">
              <div className="header-content">
                <div className="header-icon">
                  <FaImage />
                </div>
                <div className="header-text">
                  <h1>Agregar Fotografía</h1>
                  <p>Sube una nueva imagen y asígnala a una categoría</p>
                </div>
              </div>
            </div>

            {/* Form Card */}
            <Card className="form-card">
              <Card.Body>
                <Form onSubmit={handleSubmit}>
                  <Row>
                    {/* File Upload Field */}
                    <Col lg={12} md={12} className="mb-4">
                      <Form.Group>
                        <Form.Label className="form-label">
                          <FaUpload className="field-icon" />
                          Fotografía
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="file"
                          accept="image/png, image/jpeg"
                          onChange={handleChangeFile}
                          className={`form-control-custom file-input ${errors.file ? 'is-invalid' : ''}`}
                        />
                        <Form.Text className="text-muted">
                          Formatos permitidos: PNG, JPEG. Tamaño máximo: 1 MB
                        </Form.Text>
                        {errors.file && (
                          <div className="error-message">
                            <FaExclamationTriangle className="error-icon" />
                            {errors.file}
                          </div>
                        )}
                      </Form.Group>
                    </Col>

                    {/* Category Field */}
                    <Col lg={12} md={12} className="mb-4">
                      <Form.Group className="position-relative">
                        <Form.Label className="form-label">
                          <FaFolderOpen className="field-icon" />
                          Categoría
                          <span className="required-field">*</span>
                        </Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Buscar o agregar categoría"
                          value={inputValue}
                          onChange={handleInput}
                          onFocus={() => setShowSuggestions(inputValue.length > 0)}
                          className={`form-control-custom ${errors.category ? 'is-invalid' : ''}`}
                        />
                        {showSuggestions && inputValue && (
                          <div className="suggestions-dropdown">
                            {categories
                              .filter(category =>
                                category.categoryName
                                  .toLowerCase()
                                  .includes(inputValue.toLowerCase())
                              )
                              .map((category) => (
                                <div
                                  key={category.id}
                                  className="suggestion-item"
                                  onClick={() => handleCategorySelect(category)}
                                >
                                  <FaFolderOpen className="suggestion-icon" />
                                  {category.categoryName}
                                </div>
                              ))}
                            {categories.filter(category =>
                              category.categoryName
                                .toLowerCase()
                                .includes(inputValue.toLowerCase())
                            ).length === 0 && (
                              <div className="suggestion-item no-results">
                                <FaExclamationTriangle className="suggestion-icon" />
                                No se encontraron categorías
                              </div>
                            )}
                          </div>
                        )}
                        {errors.category && (
                          <div className="error-message">
                            <FaExclamationTriangle className="error-icon" />
                            {errors.category}
                          </div>
                        )}
                      </Form.Group>
                    </Col>
                  </Row>

                  {/* Action Buttons */}
                  <div className="form-actions">
                    <Button
                      type="button"
                      variant="outline-secondary"
                      className="cancel-button"
                      onClick={handleCancel}
                      disabled={isLoading}
                    >
                      Cancelar
                    </Button>
                    <Button
                      type="submit"
                      variant="primary"
                      className="save-button"
                      disabled={isLoading}
                    >
                      {isLoading ? (
                        <>
                          <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                          Subiendo...
                        </>
                      ) : (
                        <>
                          <FaSave className="me-2" />
                          Agregar Fotografía
                        </>
                      )}
                    </Button>
                  </div>
                </Form>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  )
}
